import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class LCDGraphWidgetClearNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LCD Line Graph Clear';
        this.id = 'node_lcd_graph_widget_clear';
        this.linkedFeature = 'lcd';
        this.icon = 'CgClear';

        this.inputs = [
            {
                name: 'Clear Graph',
                portId: 'lcd_graph_clear',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'WIDGET',
                name: 'Widget',
                settingType: SettingType.OPTION,
                refId: 'lcd_graph_widget',
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const widget = project.getFeature(this.getSettingValue('WIDGET'));

        if (!widget) {
            return blocks;
        }

        const SCREEN = project.getParent(widget);
        const displayFeature = project.getParent(SCREEN);
        const screens = displayFeature.getSettingValue('SCREENS');
        let widgetIndex = 0;
        let tmpWidgetIndex = 0;
        let screenIndex = 0;

        for (let j = 0; j < screens.length; j++) {
            const screen = screens[j];
            const widgets = screen.getSettingValue('WIDGETS');
            for (let i = 0; i < widgets.length; i++) {
                const currentWidget = widgets[i];
                const type = currentWidget.id;
                switch (type) {
                    case 'lcd_graph_widget':
                        if (currentWidget.getID() === widget.getID()) {
                            widgetIndex = tmpWidgetIndex;
                            break;
                        }
                        tmpWidgetIndex++;
                        break;
                }
            }
            if (screen.getID() === SCREEN.getID()) {
                screenIndex = j;
                break;
            }
        }


        const links = project.getNodeLinks(this, 'lcd_graph_clear');
        const doneLinks = project.getNodeLinks(this, 'done');

        const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    lcd_graph_widgets(${widgetIndex}).current_index = 0

    if display_current_screen = ${screenIndex} then
		lcd_draw_graph(lcd_graph_widgets(${widgetIndex}))
    end if
    ${doneBlock}`,
            });
        }


        return blocks;
    }

    getDetails(): string {
        return 'Adds a datapoint to the LCD screen chart of the selected widget. The datapoint is the current value of the widget\'s variable.';
    }
}
